<template>
    <div id="deco-homes-wrapper">
        <div id="deco-portfolio">
            <PortfolioHeader 
                :pageName="pageName"
                :disciplines="disciplines" 
                :services="services"
                :pageLink="pageLink"
                :linkName="linkName"
            />
            <section class="bg-black text-white">
                <b-container class="py-100">
                    <p class="gotham-bold">
                        WEBSITE
                    </p>
                    <p class="gotham-book mb-0">
                        DECO Homes helped shape the landscape of southern Ontario and is without question the GTA's most Design Forward homebuilder. As such, we created a website that conveys DECO's signature stylistic vision through a smooth user interface. Original imagery, a minimalistic design aesthetic, and simple copy convey DECO's unique brand positioning – while offering a realistic view of inspired Design <span style="font-style: italic">Forward</span> living.
                    </p>
                </b-container>
            </section>
            <section>
                <video src="/videos/deco-portfolio-header-video.mp4" playsinline autoplay loop muted class="w-100 d-block"></video>
            </section>
            <section>
                <FullWidthSlider 
                :slides="firstSliderItems"
                :styles="firstSliderStyles"/>
            </section>
            <section>
                <video src="/videos/deco-design-forward.mp4" playsinline autoplay loop muted class="w-100 d-block"></video>
            </section>
            <section>
                <ImageAndTextPortfolio 
                    :imageAndTextContent="imageAndTextContent"
                />
            </section>
            <section>
                <FullWidthImageSlider :sliderImages="fullWidthSliderImages"/>
            </section>
            <section>
                <ImageAndTextPortfolio 
                    :imageAndTextContent="secondImageAndTextContent"
                />
            </section>
            <section class="conclusion">
                <b-container class="next-project stipple-bg py-5" fluid>
                    <NextProject :nextProject="nextProject"/>
                </b-container>
            </section>
            <Transition1063 />
            <AppFooter />
        </div>
        <!-- <div>
            <FullWidthSlider2 
            :slides="secondSliderItems"
            :styles="secondSliderStyles"/>
        </div> -->
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    head: {
      title: "Guidelines Advertising Inc - 1063 Eglinton Ave",
      meta: [
        {
            hid: "description",
            content:
            "Guidelines Advertising is a full-service real estate marketing company with over 35 years experience in Toronto, Ontario, Canada."
        },
        { 
            hid: 'keywords', 
            name: 'keywords', 
            content: 'Toronto,Real estate décor consulting Toronto, real estate, marketing, toronto, branding, social media, web development, interior design, print, advertising, content marketing, eglinton'
        }
      ]
    },
    data() {
        return {
            scrollSmoother_decoHomes: null,
            textAnimation_decoHomes: null,
            fadeInUpElement_decoHomes: null,
            disciplines: [
                {
                    name: "corporate"
                }
            ],
            services: [
                {
                    name: "corporate identity creation"
                },
                {
                    name: "brochure design"
                },
                {
                    name: "web design & development"
                },
                {
                    name: "web hosting & management"
                },
                {
                    name: "social media/content"
                },
                {
                    name: "marketing & digital advertising"
                },
                {
                    name: "radio & web video advertising"
                }
            ],
            pageName: "Deco Homes",
            pageLink: "",
            linkName: "",
            fullWidthSliderImages: [
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-1.jpg",
                    alt: "DECO Magazie"
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-2.jpg",
                    alt: "DECO Magazie"
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-3.jpg",
                    alt: "DECO Magazie"
                }
            ],
            firstSliderStyles: {
                bgColor: '#e7e4dc',
                textColor: '#000',
                sliderClass: 'slider-dots-black',
                imgOnLeftSide: true,
                heading: "CORPORATE INITIATIVES",
                desc: "DECO takes pride in their communities and values the experience of their homeowners above all else. They go to great lengths to ensure homebuyers and community members are taken care of, from the start of the purchasing process to long after residents have moved in. 1063 helped bring crucial corporate initiatives like the DECO Homeowner's Manual, DECO Concierge Service, Seasonal Home Maintenance Checklist, and the DECO Purchaser Checklist to life. <br/><br/>The DECO Ice Cream Truck is our favourite, though. What began as an experiential marketing campaign was so beloved by community members that it became an annual DECO event. At the height of summer, DECO commissions a branded ice cream truck to visit their GTA communities and give everyone free treats. The goal is simple: to show how nothing is sweeter than a DECO community while thanking individuals and families for calling DECO home. ",
                subheading: ''
            },
            firstSliderItems: [
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    alt: "DECO Concierge"
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-icecream.jpg",
                    alt: "DECO Ice Cream Truck"
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine.jpg",
                    alt: "DECO Magazine"
                }
            ],
            secondSliderStyles: {
                bgColor: '#000',
                textBackgroundImg: 'stipple-bg',
                imgOnLeftSide: false,
                imgPadding: false,
                textColor: 'text-black',
                sliderClass: false,
                heading: "GUERILLA MARKETING CAMPAIGN",
                desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                subheading: ''
            },
            secondSliderItems: [
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "CORPORATE INITIATIVES",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                    subheading: 'DECO CONCIERGE'
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "CORPORATE INITIATIVES",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                    subheading: 'DECO CONCIERGE'
                }
            ],
            imageAndTextContent: {
                imgOnLeftSide: true,
                imgPadding: false,
                bgColor: '#000',
                bgImageClass: "",
                textColor: "#fff",
                img: "/img/portfolio/deco/deco-magazine.jpg",
                alt: "DECO Magazine Design Trends",
                heading: "MAGAZINE",
                desc: "The DECO Décor and Design Trends magazines are how we keep you apprised of the newest home, fashion, lifestyle, and technology trends. These free digital resources are available to all and continue to inspire homeowners across the GTA. With all the latest styles all in one spot, they successfully extend DECO's Design Forward philosophy to everyone."
            },
            secondImageAndTextContent: {
                imgOnLeftSide: false,
                imgPadding: false,
                bgColor: '#e7e4dc',
                bgImageClass: "",
                textColor: "#000",
                img: false,
                video: "/videos/Deco-social.mp4",
                alt: "DECO Magazine Design Trends",
                heading: "SOCIAL MEDIA",
                desc: "DECO's social media campaign combines creative interior design with community member experiences to embody this award-winning builder's corporate philosophy. We've created a genuine and aspirational brand image by highlighting modern design trends and showcasing interviews with community members inside their DECO homes. This campaign continues to inspire users across YouTube, TikTok, Twitter, and Instagram."
            },
            nextProject: {
                link: "/portfolio/the-pier",
                name: "The Pier"
            }
        }
    },
    components: {
        PortfolioHeader: () => import('@/components/PortfolioHeader'),
        FullWidthSlider: () => import('@/components/FullWidthSlider'),
        FullWidthSlider2: () => import('@/components/FullWidthSlider2'),
        ImageAndTextPortfolio: () => import('@/components/ImageAndTextPortfolio'),
        FullWidthImageSlider: () => import('@/components/FullWidthImageSlider'),
        Transition1063: () => import('@/components/Transition1063'),
        NextProject: () => import('@/components/NextProject'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initscrollSmoother_decoHomes();
            // 
            this.initImgElReveal_decoHomes();
            this.initTextReveal_decoHomes();
        }, 500)
    },
    methods: {
        initscrollSmoother_decoHomes() {
            this.scrollSmoother_decoHomes = ScrollSmoother.create({
                wrapper: '#deco-homes-wrapper',
                content: "#deco-portfolio",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_decoHomes.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_decoHomes() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let fadeInUpElement_decoHomes = this.fadeInUpElement_decoHomes;
                fadeInUpElement_decoHomes = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                fadeInUpElement_decoHomes.set(container, { autoAlpha: 1 });
                fadeInUpElement_decoHomes.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
        initTextReveal_decoHomes() {
            let revealText = document.querySelectorAll(".reveal-text");
            revealText.forEach((container) => {
                let textAnimation_decoHomes = this.textAnimation_decoHomes;
                textAnimation_decoHomes = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.1
                    }
                });

                var splitHide = new SplitText(container, { type: "words", wordsClass: "hide-text" });
                var split = new SplitText(container, {
                    type: "words,lines",
                    wordsClass: "words",
                    linesClass: "lines"
                });
                textAnimation_decoHomes.set(container, { autoAlpha: 1 });
                textAnimation_decoHomes.from(split.words, {
                    delay: 0.5,
                    duration: 0.35,
                    yPercent: 100,
                    stagger: 0.03,
                    ease: 'power2.out'
                });
            })
        }
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_decoHomes.kill();
        }, 500)
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables';

</style>